import api from "../../../services/api";
import { logout } from "../user.middleware";
import { decryptIfEncrypted } from "../../../utils/fieldDecryptor";
import { getRequestReplacingEmptyStringsToNull } from "../../../utils/utils";
import { endLoading, initLoading, setError } from "../../slices/generics.slice";
import { setCompanies, setEconomicGroups } from "../../slices/b2b/b2bCompanies.slice";

const emptyFilter = {
  pageNumber: 1,
  pageSize: 999,
  socialName: "",
  fantasyName: "",
  documentNumber: "",
  economicGroupId: "",
  registerDateFrom: "",
  registerDateTo: "",
  active: "",
};

export const fetchCompanies = (filter = "") => {
  return async (dispatch) => {
    dispatch(initLoading());

    const req = getRequestReplacingEmptyStringsToNull(emptyFilter, filter);

    try {
      const response = await api.post("/companies/search", req);

      const resp = response?.data?.result?.items;
      dispatch(setCompanies(resp));
    } catch (error) {
      console.log("fetchCompanies", error);
      dispatch(setError(error.message));
    } finally {
      dispatch(endLoading());
    }
  };
};

export const saveCompany = (data) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      await api.post("/companies", data);
    } catch (error) {
      logout();
      console.log("fetchCompanies", error);
      dispatch(setError(error.message));
    } finally {
      dispatch(endLoading());
    }
  };
};

export const editCompany = (data) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      await api.put("/companies", data);
    } catch (error) {
      console.log("fetchCompanies", error);
      dispatch(setError(error.message));
    } finally {
      dispatch(endLoading());
    }
  };
};

export const fetchEconomicGroups = () => {
  return async (dispatch) => {
    dispatch(initLoading());

    const req = {
      name: null,
      code: null,
      description: null,
      active: null,
      skip: null,
      take: null,
    };

    try {
      const response = await api.post("/economicgroups/search", req);
      const resp = response?.data?.result?.items.map((item) => ({ ...item, name: decryptIfEncrypted(item.name) }));

      dispatch(setEconomicGroups(resp.sort((a, b) => (a.name > b.name ? 1 : -1))));
    } catch (error) {
      console.log("fetchEconomicGroups", error);
      dispatch(setError(error.message));
    } finally {
      dispatch(endLoading());
    }
  };
};
